// Copyright (c) 2019 Deere & Company

import OktaState from '../state/okta-state';
import actions from '../../shared/actions-list';
import { getDefaultState } from '../state';

const updateAccessToken = ( state, action ) => OktaState.update( state, {
    accessToken: {
        $set: action.accessToken,
    },
} );

const updateIsAuthenticated = ( state, action ) => OktaState.update( state, {
    isAuthenticated: {
        $set: action.isAuthenticated,
    },
} );

const updateUserFirstName = ( state, action ) => OktaState.update( state, {
    userFirstName: {
        $set: action.userFirstName,
    },
} );

export default ( state = getDefaultState().oktaState, action ) => {

    const actionTypes = {
        [actions.UPDATE_OKTA_STATE_ACCESS_TOKEN]: updateAccessToken,
        [actions.UPDATE_OKTA_STATE_IS_AUTHENTICATED]: updateIsAuthenticated,
        [actions.UPDATE_OKTA_STATE_USER_FIRST_NAME]: updateUserFirstName,
    };

    const reducer = actionTypes[action.type];

    return reducer
        ? reducer( state, action )
        : state;

};
